import gynaecology from './gynaecology.const';
import study from './study.const';
import ophthalmology from './ophthalmology.const';
import anesthesia from './anesthesia.const';
import pediatrics from './pediatrics.const';
import surgery from './surgery.const';
import cardiology from './cardiology.const';
import neurology from './neurology.const';
import geriatrics from './geriatrics.const';
import oncology from './oncology.const';
import dermatology from './dermatology.const';
import gastroenterology from './gastroenterology.const';
import nephrology from './nephrology.const';

export default {
    cardiology,
    nephrology,
    study,
    neurology,
    gynaecology,
    ophthalmology,
    anesthesia,
    pediatrics,
    surgery,
    geriatrics,
    oncology,
    dermatology,
    gastroenterology,
};
